/**
 * Context for integrated component defaults (apiClient, tenant, module).
 *
 * Components use useIntegratedComponentContext() to read defaults.
 * Returns null when used outside a provider — callers must handle this.
 */

import { createContext, useContext } from 'react';
import type { IntegratedComponentContextValue } from './types';

export const IntegratedComponentContext =
  createContext<IntegratedComponentContextValue | null>(null);

IntegratedComponentContext.displayName = 'IntegratedComponentContext';

/**
 * Read the integrated component context.
 * Returns `null` when called outside a provider (does NOT throw).
 */
export function useIntegratedComponentContext(): IntegratedComponentContextValue | null {
  return useContext(IntegratedComponentContext);
}
